import React from 'react';
import { AiOutlineSearch } from 'react-icons/ai';

const FinancialListModal = ({
  isOpen,
  onClose,
  title,
  badge,
  searchPlaceholder,
  search,
  onSearchChange,
  onNew,
  newLabel = '+ Novo',
  headerExtra,
  children,
}) => {
  if (!isOpen) return null;

  return (
    <div className="fd-modal-overlay" onClick={onClose}>
      <div className="fd-modal fd-modal--lg" onClick={(e) => e.stopPropagation()}>
        <div className="fd-modal-header">
          <div className="fd-modal-header-left">
            <h3 className="fd-modal-title">{title}</h3>
            {badge != null && <span className="fd-modal-badge">{badge}</span>}
          </div>
          <div className="fd-modal-header-right">
            <div className="fd-modal-search">
              <AiOutlineSearch className="fd-modal-search-icon" />
              <input
                type="text"
                placeholder={searchPlaceholder}
                value={search}
                onChange={(e) => onSearchChange(e.target.value)}
                aria-label={searchPlaceholder}
              />
            </div>
            {headerExtra}
            {onNew && (
              <button className="fd-btn-green" type="button" onClick={onNew}>{newLabel}</button>
            )}
            <button className="fd-btn-close" type="button" onClick={onClose}>Fechar</button>
          </div>
        </div>
        {children}
      </div>
    </div>
  );
};

export default FinancialListModal;
